var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "form-overlay select-mention add-alt-text",
      class: _vm.position,
    },
    [
      _c("div", { staticClass: "steep1" }, [
        _c("p", [_vm._v(_vm._s(_vm.title))]),
        _c("div", { staticClass: "content searchMention" }, [
          _c("div", { staticClass: "input" }, [
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.model.input,
                  expression: "model.input",
                },
              ],
              ref: "inputSearch",
              attrs: { placeholder: _vm.placeholder },
              domProps: { value: _vm.model.input },
              on: {
                input: [
                  function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.model, "input", $event.target.value)
                  },
                  function ($event) {
                    return _vm.resize()
                  },
                ],
              },
            }),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "btn-secondary", on: { click: _vm.close } }, [
        _vm._v(_vm._s(_vm.$t("dash.button.close"))),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }